import React, { useState, useEffect, useContext } from 'react';
import { Link } from 'react-router-dom'; // Import Link from React Router

import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';

import { useNavigate } from 'react-router-dom';
//import Link from '@mui/material/Link';
import { AuthContext } from '../AuthContext';
import { ThemeContext } from '../ThemeContext';
import Button from '@mui/material/Button'
import Tooltip from '@mui/material/Tooltip'

import LogoutTwoToneIcon from '@mui/icons-material/LogoutTwoTone';
import LoginTwoToneIcon from '@mui/icons-material/LoginTwoTone';
import Brightness4Icon from '@mui/icons-material/Brightness4';
import Brightness7Icon from '@mui/icons-material/Brightness7';
import imgCma from '../media/cma.svg'; // Change the path to your image
import Stack from '@mui/material/Stack'
import Chip from '@mui/material/Chip';
import UserAvatar from './UserAvatar';


function Navbar() {
  const { user, signOut, isAuthenticated } = useContext(AuthContext);
  const { mode, toggleTheme } = useContext(ThemeContext);


  const [isauth, setIsAuth] = useState(false);
  const navigate = useNavigate();
  const isDev = process.env.REACT_APP_ENV === 'development';

  useEffect(() => {
    setIsAuth(isAuthenticated());
  }, [user]);


  const goSignIn = () => {
    navigate('/auth/signin');
  };

  return (
    <>
      {/* Colored strips on navbar */}
      <div className="lines">
        <div className="line lineRed"></div>
        <div className="line lineGreen"></div>
        <div className="line lineYellow"></div>
      </div>

      <AppBar component="nav" sx={{ backgroundColor:  (theme) => theme.palette.primary.contrastText, color:  (theme) => theme.palette.text.primary  }}>
        <Toolbar style={{ justifyContent: 'space-between' }}>

        <Link to={isauth ? "/home" : "/"}>
          <IconButton edge="end" color="inherit" aria-label="logo" disableFocusRipple={true} disableRipple>
            <img
              width="85"
              height="45"
              src={imgCma}
              alt="Logo"
            />
          </IconButton>
        </Link>

        {isDev && (
          <Chip
            label="Development"
            size="small"
            sx={{
              backgroundColor: '#f59e0b',
              color: '#fff',
              fontWeight: 600,
              letterSpacing: '0.05em',
              fontSize: '0.7rem',
            }}
          />
        )}

        <Stack direction="row" spacing={2} alignItems="center">
          {/* Theme Toggle Button */}
          <Tooltip title={mode === 'dark' ? 'Switch to light mode' : 'Switch to dark mode'}>
            <IconButton
              onClick={toggleTheme}
              color="inherit"
              sx={{
                color: (theme) => theme.palette.primary.main,
                transition: 'all 0.3s ease',
                '&:hover': {
                  transform: 'rotate(180deg)',
                  backgroundColor: (theme) => theme.palette.action.hover,
                },
              }}
            >
              {mode === 'dark' ? <Brightness7Icon /> : <Brightness4Icon />}
            </IconButton>
          </Tooltip>

          {isauth ? (
            <>
              <UserAvatar username={user?.username} fresh={true}></UserAvatar>

              <Button
                endIcon={<LogoutTwoToneIcon />}
                size="medium"
                edge="start"
                color="inherit"
                aria-label="menu"
                sx={{ mr: 2, color: (theme) => theme.palette.primary.main, textTransform: 'none' }}
                onClick={() => signOut()}
              >
                Sign out
              </Button>
            </>
          ) : (
            <Button
              endIcon={<LoginTwoToneIcon />}
              size="medium"
              edge="start"
              color="inherit"
              aria-label="menu"
              sx={{ mr: 2, color: (theme) => theme.palette.primary.main, textTransform: 'none' }}
              onClick={goSignIn}
            >
              Sign in
            </Button>
          )}
        </Stack>


      </Toolbar>
    </AppBar>
    </>
  );
}

export default Navbar;
